(() => {
  'use strict';
  document.querySelectorAll('[data-cebe-business-application]').forEach(root => {
    const panels = [...root.querySelectorAll('[data-application-panel]')];
    const steps = [...root.querySelectorAll('[data-application-step]')];
    const strings = JSON.parse(root.querySelector('[data-application-strings]').textContent);
    const status = root.querySelector('[data-application-status]');
    const files = new Map();
    const versions = new Map();
    let current = 0;
    function show(index, focus = true) {
      current = index;
      panels.forEach((panel, i) => { panel.hidden = i !== index; });
      steps.forEach((step, i) => {
        step.disabled = i > current + 1;
        if (i === index) step.setAttribute('aria-current', 'step');
        else step.removeAttribute('aria-current');
      });
      root.dataset.currentStep = String(index + 1);
      status.textContent = strings.step.replace('[count]', String(index + 1));
      if (index === 2) review();
      if (focus) panels[index].querySelector('[data-panel-title]')?.focus();
    }
    function valid(index) {
      const controls = panels[index].querySelectorAll('input,select');
      for (const control of controls) {
        if (!control.checkValidity()) { control.reportValidity(); control.focus(); return false; }
      }
      if (index === 1 && files.size !== 2) { status.textContent = strings.documents; return false; }
      return true;
    }
    function review() {
      root.querySelectorAll('[data-review-field]').forEach(node => {
        const input = root.querySelector('[name="' + node.dataset.reviewField + '"]');
        node.textContent = input?.value?.trim() || strings.empty;
      });
      root.querySelectorAll('[data-review-document]').forEach(node => {
        const file = files.get(node.dataset.reviewDocument);
        node.textContent = file ? file.name : strings.empty;
      });
    }
    function safeName(name) { return name.replace(/[\u0000-\u001f\u007f]/g, '').slice(0,160); }
    async function select(input) {
      const card = input.closest('[data-document-card]');
      const feedback = card.querySelector('[data-document-status]');
      const key = input.dataset.document;
      const version = (versions.get(key) || 0) + 1;
      versions.set(key, version);
      files.delete(key);
      input.setCustomValidity('');
      card.querySelector('[data-document-remove]').hidden = true;
      const file = input.files?.[0];
      if (!file) { feedback.textContent = strings.notSelected; return; }
      feedback.textContent = strings.checking;
      try {
        if (file.size < 1 || file.size > 10 * 1024 * 1024) throw new Error(strings.size);
        const bytes = new Uint8Array(await file.slice(0,8).arrayBuffer());
        const ext = file.name.split('.').pop().toLowerCase();
        const pdf = ['pdf'].includes(ext) && bytes[0] === 37 && bytes[1] === 80 && bytes[2] === 68 && bytes[3] === 70 && bytes[4] === 45;
        const jpeg = ['jpg','jpeg'].includes(ext) && bytes[0] === 255 && bytes[1] === 216 && bytes[2] === 255;
        const png = ext === 'png' && [137,80,78,71,13,10,26,10].every((byte,i) => bytes[i] === byte);
        if (!pdf && !jpeg && !png) throw new Error(strings.format);
        if (versions.get(key) !== version) return;
        files.set(key, { name: safeName(file.name), bytes: file.size });
        feedback.textContent = strings.selected.replace('[name]', safeName(file.name));
        card.querySelector('[data-document-remove]').hidden = false;
      } catch (error) {
        if (versions.get(key) !== version) return;
        input.value = ''; input.setCustomValidity(error.message); feedback.textContent = error.message;
      }
    }
    root.querySelectorAll('[data-document]').forEach(input => input.addEventListener('change', () => select(input)));
    root.querySelectorAll('[data-document-remove]').forEach(button => button.addEventListener('click', () => {
      const input = button.closest('[data-document-card]').querySelector('[data-document]');
      input.value = ''; select(input);
    }));
    root.querySelectorAll('[data-application-next]').forEach(button => button.addEventListener('click', () => {
      if (valid(current)) show(Math.min(2, current + 1));
    }));
    root.querySelectorAll('[data-application-back]').forEach(button => button.addEventListener('click', () => show(Math.max(0, current - 1))));
    steps.forEach((button,index) => button.addEventListener('click', () => {
      if (index <= current || (index === current + 1 && valid(current))) show(index);
    }));
    root.addEventListener('submit', event => { event.preventDefault(); event.stopImmediatePropagation(); });
    root.querySelector('[data-application-finish]')?.addEventListener('click', event => {
      event.preventDefault(); status.textContent = strings.closed;
    });
    show(0, false);
    const detail = root.closest('details');
    if (location.hash === '#CebeB2BApplication' && detail) detail.open = true;
    window.addEventListener('hashchange', () => { if (location.hash === '#CebeB2BApplication' && detail) detail.open = true; });
  });
})();
